export default __webpack_public_path__ + "static/media/smartSwitch.14a79284.png";